export default {
    HIOPOSWEBSERVICES: 'https://hiopos-dev-staging.saas.com.co',
    HIOPOSREPORTS: 'https://hioposreports-dev-staging.saas.com.co',
  }
  